import { Container } from '@mui/material';
import React from 'react';

function ContainerFrame(props: IContainerFrameProps) {
  const { children } = props;

  return (
    <Container maxWidth="lg">
      {children}
    </Container>
  );
}

interface IContainerFrameProps {
  children: React.ReactNode;
}

export type { IContainerFrameProps };
export { ContainerFrame };
